import { FirebaseError } from "firebase/app";
import { Toasts } from "../../helpers/helpers";

export const generateFirebaseAuthErrorMessage = (error: FirebaseError) => {
    switch (error?.code) {
        case "auth/invalid-email":
            Toasts.error("Invalid email address. Please enter a valid email.");
            break;
        case "auth/user-not-found":
            Toasts.error("User not found. Please check the email address.");
            break;
        case "auth/wrong-password":
            Toasts.error("Incorrect password. Please try again.");
            break;
        case "auth/email-already-in-use":
            Toasts.error("Email already in use. Please try another email.");
            break;
        case "auth/weak-password":
            Toasts.error("Password should be at least 6 characters.");
            break;
        case "auth/operation-not-allowed":
            Toasts.error("Operation not allowed. Please try again later.");
            break;
        case "auth/invalid-verification-code":
            Toasts.error("Invalid verification code. Please try again.");
            break;
        case "auth/invalid-verification-id":
            Toasts.error("Invalid verification ID. Please try again.");
            break;
        case "auth/code-expired":
            Toasts.error("Code expired. Please try again.");
            break;
        case "auth/invalid-action-code":
            Toasts.error("Invalid action code. Please try again.");
            break;
        case "auth/user-disabled":
            Toasts.error("User disabled. Please contact support.");
            break;
        case "auth/invalid-credential":
            Toasts.error("Invalid credential. Please try again.");
            break;
        case "auth/invalid-continue-uri":
            Toasts.error("Invalid continue URL. Please try again.");
            break;
        case "auth/unauthorized-continue-uri":
            Toasts.error("Unauthorized continue URL. Please try again.");
            break;
        case "auth/missing-continue-uri":
            Toasts.error("Missing continue URL. Please try again.");
            break;
        case "auth/missing-verification-code":
            Toasts.error("Missing verification code. Please try again.");
            break;
        case "auth/missing-verification-id":
            Toasts.error("Missing verification ID. Please try again.");
            break;
        case "auth/captcha-check-failed":
            Toasts.error("Captcha check failed. Please try again.");
            break;
        case "auth/invalid-phone-number":
            Toasts.error("Invalid phone number. Please try again.");
            break;
        case "auth/missing-phone-number":
            Toasts.error("Missing phone number. Please try again.");
            break;
        case "auth/quota-exceeded":
            Toasts.error("Quota exceeded. Please try again.");
            break;
        case "auth/missing-app-credential":
            Toasts.error("Missing app credential. Please try again.");
            break;
        case "auth/invalid-app-credential":
            Toasts.error("Invalid app credential. Please try again.");
            break;
        case "auth/session-expired":
            Toasts.error("Session expired. Please try again.");
            break;
        case "auth/missing-or-invalid-nonce":
            Toasts.error("Missing or invalid nonce. Please try again.");
            break;
        case "auth/missing-client-identifier":
            Toasts.error("Missing client identifier. Please try again.");
            break;
        case "auth/key-retrieval-failed":
            Toasts.error("Key retrieval failed. Please try again.");
            break;
        case "auth/invalid-oauth-provider":
            Toasts.error("Invalid OAuth provider. Please try again.");
            break;
        case "auth/invalid-oauth-client-id":
            Toasts.error("Invalid OAuth client ID. Please try again.");
            break;
        case "auth/invalid-cert-hash":
            Toasts.error("Invalid cert hash. Please try again.");
            break;
        case "auth/invalid-user-token":
            Toasts.error("Invalid user token. Please try again.");
            break;
        case "auth/invalid-custom-token":
            Toasts.error("Invalid custom token. Please try again.");
            break;
        case "auth/app-deleted":
            Toasts.error("App deleted. Please try again.");
            break;
        case "auth/app-not-authorized":
            Toasts.error("App not authorized. Please try again.");
            break;
        case "auth/argument-error":
            Toasts.error("Argument error. Please try again.");
            break;
        case "auth/invalid-api-key":
            Toasts.error("Invalid API key. Please try again.");
            break;
        case "auth/network-request-failed":
            Toasts.error("Network request failed. Please try again.");
            break;
        case "auth/requires-recent-login":
            Toasts.error("Requires recent login. Please try again.");
            break;
        case "auth/too-many-requests":
            Toasts.error("Too many requests. Please try again.");
            break;
        case "auth/unauthorized-domain":
            Toasts.error("Unauthorized domain. Please try again.");
            break;
        case "auth/user-token-expired":
            Toasts.error("User token expired. Please try again.");
            break;
        case "auth/web-storage-unsupported":
            Toasts.error("Web storage unsupported. Please try again.");
            break;
        case "auth/account-exists-with-different-credential":
            Toasts.error("Account exists with different credential. Please try again.");
            break;
        case "auth/auth-domain-config-required":
            Toasts.error("Auth domain config required. Please try again.");
            break;
        case "auth/cancelled-popup-request":
            Toasts.error("Cancelled popup request. Please try again.");
            break;
        case "auth/credential-already-in-use":
            Toasts.error("Credential already in use. Please try again.");
            break;
        case "auth/custom-token-mismatch":
            Toasts.error("Custom token mismatch. Please try again.");
            break;
        case "auth/provider-already-linked":
            Toasts.error("Provider already linked. Please try again.");
            break;
        case "auth/timeout":
            Toasts.error("Timeout. Please try again.");
            break;
        case "auth/missing-android-pkg-name":
            Toasts.error("Missing Android package name. Please try again.");
            break;
        case "auth/missing-ios-bundle-id":
            Toasts.error("Missing iOS bundle ID. Please try again.");
            break;
        case "auth/invalid-dynamic-link-domain":
            Toasts.error("Invalid dynamic link domain. Please try again.");
            break;
        case "auth/invalid-persistence-type":
            Toasts.error("Invalid persistence type. Please try again.");
            break;
        case "auth/unsupported-persistence-type":
            Toasts.error("Unsupported persistence type. Please try again.");
            break;
        case "auth/invalid-oauth-client-secret":
            Toasts.error("Invalid OAuth client secret. Please try again.");
            break;
        case "auth/invalid-argument":
            Toasts.error("Invalid argument. Please try again.");
            break;
        case "auth/invalid-creation-time":
            Toasts.error("Invalid creation time. Please try again.");
            break;
        case "auth/invalid-disabled-field":
            Toasts.error("Invalid disabled field. Please try again.");
            break;
        case "auth/invalid-display-name":
            Toasts.error("Invalid display name. Please try again.");
            break;
        case "auth/invalid-email-verified":
            Toasts.error("Invalid email verified. Please try again.");
            break;
        case "auth/invalid-hash-algorithm":
            Toasts.error("Invalid hash algorithm. Please try again.");
            break;
        case "auth/invalid-hash-block-size":
            Toasts.error("Invalid hash block size. Please try again.");
            break;
        case "auth/invalid-hash-derived-key-length":
            Toasts.error("Invalid hash derived key length. Please try again.");
            break;
        case "auth/invalid-hash-key":
            Toasts.error("Invalid hash key. Please try again.");
            break;
        case "auth/invalid-hash-memory-cost":
            Toasts.error("Invalid hash memory cost. Please try again.");
            break;
        case "auth/invalid-hash-parallelization":
            Toasts.error("Invalid hash parallelization. Please try again.");
            break;
        case "auth/invalid-hash-rounds":
            Toasts.error("Invalid hash rounds. Please try again.");
            break;
        case "auth/invalid-hash-salt-separator":
            Toasts.error("Invalid hash salt separator. Please try again.");
            break;
        case "auth/invalid-id-token":
            Toasts.error("Invalid ID token. Please try again.");
            break;
        case "auth/invalid-last-sign-in-time":
            Toasts.error("Invalid last sign in time. Please try again.");
            break;
        case "auth/invalid-page-token":
            Toasts.error("Invalid page token. Please try again.");
            break;
        case "auth/invalid-password":
            Toasts.error("Invalid password. Please try again.");
            break;
        case "auth/invalid-password-hash":
            Toasts.error("Invalid password hash. Please try again.");
            break;
        case "auth/invalid-password-salt":
            Toasts.error("Invalid password salt. Please try again.");
            break;
        case "auth/invalid-photo-url":
            Toasts.error("Invalid photo URL. Please try again.");
            break;
        case "auth/invalid-provider-id":
            Toasts.error("Invalid provider ID. Please try again.");
            break;
        case "auth/invalid-session-cookie-duration":
            Toasts.error("Invalid session cookie duration. Please try again.");
            break;
        case "auth/invalid-uid":
            Toasts.error("Invalid UID. Please try again.");
            break;
        case "auth/invalid-user-import":
            Toasts.error("Invalid user import. Please try again.");
            break;
        case "auth/invalid-provider-data":
            Toasts.error("Invalid provider data. Please try again.");
            break;
        case "auth/maximum-user-count-exceeded":
            Toasts.error("Maximum user count exceeded. Please try again.");
            break;
        case "auth/missing-hash-algorithm":
            Toasts.error("Missing hash algorithm. Please try again.");
            break;
        case "auth/missing-uid":
            Toasts.error("Missing UID. Please try again.");
            break;
        case "auth/reserved-claims":
            Toasts.error("Reserved claims. Please try again.");
            break;
        case "auth/session-cookie-revoked":
            Toasts.error("Session cookie revoked. Please try again.");
            break;
        case "auth/uid-already-exists":
            Toasts.error("UID already exists. Please try again.");
            break;
        case "auth/email-already-exists":
            Toasts.error("Email already exists. Please try again.");
            break;
        case "auth/phone-number-already-exists":
            Toasts.error("Phone number already exists. Please try again.");
            break;
        case "auth/project-not-found":
            Toasts.error("Project not found. Please try again.");
            break;
        case "auth/insufficient-permission":
            Toasts.error("Insufficient permission. Please try again.");
            break;
        case "auth/internal-error":
            Toasts.error("Internal error. Please try again.");
            break;

        default:
            Toasts.error("Oops! Something went wrong. Please try again later.");
    }
};